import { request } from 'ice';
import { INBOUNDSERVICE } from '@/const';

// 入库面板tip
async function inTips(data) {
  return await request({
    url: `${INBOUNDSERVICE}/inboundBoard/countOrderPcsQty`,
    // url: `${INBOUNDSERVICE}/itaskBoard/countOrderPcsQty`,
    method: 'POST',
    data,
  });
}

async function getAllOrderQty(data) {
  return await request({
    url: `${INBOUNDSERVICE}/inboundBoard/countTotalPendingPutAwayOrderQty`,
    method: 'POST',
    data,
  });
}

export { inTips, getAllOrderQty };
